import axios from "axios";

import { getToken } from "@/utils/tokenStorage";

const API = "/api";

const headers = () => {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export async function carregarDre({ inicio, fim, regime }) {
  const { data } = await axios.get(`${API}/dre`, {
    headers: headers(),
    params: { inicio, fim, regime },
  });
  return data;
}
